export const locale = {
    lang: 'pl',
    data: {
        "Language": "Język",
        "Languages": "Języki",
    }
};
